/* src/app/components/individual-binding-options-modal/individual-binding-options-modal.component.scss */
h2 {
  font-family: "Raleway", sans-serif;
  font-size: 22px;
  font-weight: 600;
}
/*# sourceMappingURL=individual-binding-options-modal.component-WOAQGRJJ.css.map */
